import {
	faBook,
	faRobot,
	faMugHot,
	faChartPie,
	faCircle,
	faLanguage,
	faEnvelopesBulk,
	faMusic,
	faCookieBite,
	faClock,
	faCalculator,
	faQuoteRight,
	faDrum,
	faDisplay,
	faMicroscope,
	faFileCircleQuestion,
} from "@fortawesome/free-solid-svg-icons";

import {
	faReact,
	faNodeJs,
	faTypescript,
	faTailwindCss,
	faPostgresql,
	faJsSquare,
	faFigma,
	faSass,
	faCss3Alt,
	faHtml5,
} from "@fortawesome/free-brands-svg-icons";

import solidjslogo from "./components/solidjslogo.png";
import firebaselogo from "./components/firebaselogo.svg";

const projdata = [
	{
		name: "Bookworm Plugin",
		year: "2026 - current",
		goal: "Exploring full-stack and open-source projects",
		sub: "Bookworm KOReader plugin",
		desc: "Vibe-coded in lua, allows to read multiple books on a jail-broken Kindle device.",
		url: "https://github.com/GiuliaPassoni/bookworm-koreader-plugin",
		fa_icon: faBook,
		lang_class: [""],
	},
	{
		name: "Full Full-stack Project",
		year: "2026 - current",
		goal: "Exploring full-stack and open-source projects",
		sub: "The full stack - from data mocking, to BE, to FE",
		desc: "Create a UI for a production line, with simulated real-time data feed.",
		url: "https://github.com/GiuliaPassoni/rc-project",
		fa_icon: faRobot,
		lang_class: [faTypescript, faReact, faTailwindCss, faNodeJs, faPostgresql],
	},
	{
		name: "Loyalty Card Digital Wallet",
		year: "2025 - current",
		goal: "A PWA for a digital card wallet",
		sub: "TS, React 18, PWA, Zustand, Firebase",
		desc: "For when you forget your paper card, and need to prove you're a loyal customer.",
		url: "https://github.com/GiuliaPassoni/my-loyalty-app",
		fa_icon: faMugHot,
		lang_class: [faTypescript, faReact],
		png: [{ name: "Firebase", src: firebaselogo }],
	},
	{
		name: "Budget App",
		year: "2024-2025",
		goal: "Testing a new framework - solidJS",
		sub: "TS, solidJS, TailwindCSS, D3.js, Firebase",
		desc: "Personal finance management app, with data visualisations powered by D3.js.",
		url: "https://github.com/GiuliaPassoni/budget-app/blob/main/README.md",
		fa_icon: faChartPie,
		lang_class: [faTypescript, faTailwindCss],
		png: [
			{ name: "SolidJs", src: solidjslogo },
			{ name: "Firebase", src: firebaselogo },
		],
	},
	{
		name: "Breathing Exercise",
		year: "2023",
		goal: "Learning D3.js",
		sub: "D3.js and React",
		desc: "Replicating the Nerva app design, using D3.js.",
		url: "https://gp23-take-a-deep-breath.netlify.app/",
		fa_icon: faCircle,
		lang_class: [faJsSquare, faFigma, faReact, faSass],
	},
	{
		name: "Langueville",
		year: "2022",
		goal: "First client project",
		sub: "Client website",
		desc: "Private client project, featuring i18next for translations.",
		url: "https://gp23-language-project.netlify.app/",
		fa_icon: faLanguage,
		lang_class: [faJsSquare, faFigma, faReact, faSass],
	},
	{
		year: "2022",
		name: "Virtual Postcards",
		goal: "Portfolio foundations",
		sub: "API-focused website",
		desc: "Axios library, APIs, carousels, modal elements, EmailJs.",
		url: "https://gp22-postcard.netlify.app",
		fa_icon: faEnvelopesBulk,
		lang_class: [faTypescript, faReact, faSass],
	},
	{
		year: "2022",
		name: "Audio visualiser",
		goal: "Portfolio foundations",
		sub: "Audio visualiser website",
		desc: "All things React, MaterialUI, canvas, and p5js wishful thinking.",
		url: "https://audio-visualiser-5cb73.web.app/",
		fa_icon: faMusic,
		lang_class: [faCss3Alt, faHtml5, faJsSquare, faReact, faSass],
	},
	{
		year: "2022",
		name: "Recipe filter",
		goal: "Portfolio foundations",
		sub: "Recipe filter website",
		desc: "React hooks, API fetch, and a great appetite.",
		url: "https://gp22-recipe-filter.netlify.app",
		fa_icon: faCookieBite,
		lang_class: [faCss3Alt, faHtml5, faJsSquare, faReact, faSass],
	},
	{
		year: "2022",
		name: "25+5 Timer",
		goal: "Self-taught FE Bootcamp",
		sub: "Pomodoro timer",
		desc: "freeCodeCamp Frontend Library Certification project: learning React states.",
		url: "http://fcc-timer-gp22.surge.sh",
		fa_icon: faClock,
		lang_class: [faCss3Alt, faHtml5, faJsSquare, faReact],
	},
	{
		year: "2022",
		name: "Calculator",
		goal: "Self-taught FE Bootcamp",
		sub: "Online calculator",
		desc: "freeCodeCamp Frontend Library Certification project with plenty of JS conditional statements.",
		url: "https://fcc-calculator-gp22.surge.sh",
		fa_icon: faCalculator,
		lang_class: [faCss3Alt, faHtml5, faJsSquare, faReact],
	},
	{
		name: "Quote generator",
		year: "2022",
		goal: "Self-taught FE Bootcamp",
		sub: "Inspiring quotes",
		desc: "freeCodeCamp Frontend Library Certification project.",
		url: "http://fcc-quote-generator-gp22.surge.sh",
		fa_icon: faQuoteRight,
		lang_class: [faCss3Alt, faHtml5, faJsSquare, faReact],
	},
	{
		name: "Drum machine",
		year: "2022",
		goal: "Self-taught FE Bootcamp",
		sub: "Make some noise",
		desc: "freeCodeCamp Frontend Library Certification project, focused on event handling.",
		url: "http://fcc-drum-machine-gp22.surge.sh",
		fa_icon: faDrum,
		lang_class: [faCss3Alt, faHtml5, faJsSquare, faReact],
	},
	{
		name: "Md previewer",
		year: "2022",
		goal: "Self-taught FE Bootcamp",
		url: "https://fcc-markdown-previewer-gp22.surge.sh/",
		sub: "Markdown previewer",
		desc: "freeCodeCamp Frontend Library Certification project using Prism and Marked libraries in React.",
		fa_icon: faDisplay,
		lang_class: [faCss3Alt, faHtml5, faJsSquare, faReact],
	},
	{
		name: "Tribute page",
		year: "2022",
		goal: "Self-taught FE Bootcamp",
		url: "https://codepen.io/giuliapassoni/details/poaEwVw",
		sub: "to R. Levi Montalcini",
		desc: "freeCodeCamp Responsive Design Library Certification project. My first static website :)",
		fa_icon: faMicroscope,
		lang_class: [faCss3Alt, faHtml5],
	},
	{
		year: "2022",
		goal: "Self-taught FE Bootcamp",
		name: "Survey form page",
		url: "https://codepen.io/giuliapassoni/pen/bGLBryL",
		sub: "Survey form",
		desc: "freeCodeCamp Responsive Design Library Certification project, again a static website",
		fa_icon: faFileCircleQuestion,
		lang_class: [faCss3Alt, faHtml5],
	},
];

export default projdata;
